export const MAX_SORT_COLUMNS = 1;
export const ROWS_PER_PAGE = 20;
export const MIN_COLUMN_WIDTH = 100;
export const MAX_COLUMN_WIDTH = 350;
